export default "__VITE_ASSET__B_zX4IZZ__"